import { getImageUrl } from '~/lib/image/getImageUrl'

export default function Avatar({
  user,
  hejaImagesBaseUrl,
}: {
  user: { profileImage?: { url?: string } }
  hejaImagesBaseUrl: string
}) {
  const url = user.profileImage?.url || '/images/empty-avatar.svg'

  return (
    <div className="w-24 h-24 rounded-full overflow-hidden bg-neutral-300 border-4 border-white flex items-center justify-center z-30">
      <img src={getImageUrl({ url, width: 96, height: 96, hejaImagesBaseUrl })} alt="Avatar" />
    </div>
  )
}
